import { K8sProvider } from '@cast/shared-types';

import { CompatibilityMap } from './types';
import { buildAllInstances } from './utils';

const AWS_INSTANCE_COMPATIBILITY_MAP: CompatibilityMap = new Map([
  [
    'Set1',
    new Map<string, string[]>([
      ['Intel Xeon E5-2680 v2 (Ivy Bridge)', ['c3']],
      ['Intel Xeon E5-2670 v2 (Ivy Bridge/Sandy Bridge)', ['m3']],
      ['Intel Xeon E5-2670 v2 (Ivy Bridge)', ['r3', 'i2']],
    ]),
  ],
  [
    'Set2',
    new Map<string, string[]>([
      [
        'Intel Xeon 8375C (Ice Lake)',
        [
          'c6id',
          'm6in',
          'r6i',
          'm6idn',
          'c6i',
          'm6id',
          'm6i',
          'r6idn',
          'c6in',
          'r6id',
          'i4i',
          'r6in',
        ],
      ],
      [
        'Intel Xeon Scalable (Icelake)',
        ['x2iedn', 'x2idn', 'trn1', 'trn1n', 'hpc6id'],
      ],
    ]),
  ],
  [
    'Set3',
    new Map<string, string[]>([
      [
        'Intel Xeon Scalable (Sapphire Rapids)',
        [
          'm7i-flex',
          'u7in-16tb',
          'u7i-6tb',
          'trn2',
          'c7i-flex',
          'c7i',
          'p5en',
          'u7i-8tb',
          'u7in-24tb',
          'r7i',
          'r7iz',
          'u7in-32tb',
          'u7i-12tb',
          'm7i',
        ],
      ],
      ['Intel Xeon Scalable (Emerald Rapids)', ['i7ie', 'i7i', 'p6-b200']],
    ]),
  ],
  [
    'Set4',
    new Map<string, string[]>([
      ['Intel Xeon Platinum 8151', ['z1d']],
      ['Intel Xeon Platinum 8275CL (Cascade Lake)', ['inf1']],
      ['Intel Xeon Platinum 8124M', ['c5', 'c5d', 'c5n']],
      [
        'Intel Xeon Platinum 8259 (Cascade Lake)',
        ['dl2q', 'r5b', 'r5dn', 'm5dn', 'm5n', 'r5n', 'd3en', 'd3'],
      ],
      [
        'Intel Xeon Platinum 8175 (Cascade Lake)',
        ['i3en', 'm5d', 'r5', 'm5', 'r5d'],
      ],
      ['Intel Xeon Platinum 8252', ['m5zn', 'x2iezn']],
    ]),
  ],
  [
    'Set5',
    new Map<string, string[]>([
      ['Intel Xeon E5-2666 v3 (Haswell)', ['c4']],
      ['Intel Xeon E5-2676 v3 (Haswell)', ['m4', 'd2']],
    ]),
  ],
  [
    'Set6',
    new Map<string, string[]>([
      [
        'AMD EPYC 7R13 Processor',
        [
          'f2',
          'hpc6a',
          'g6e',
          'p5',
          'g6',
          'm6a',
          'gr6f',
          'r6a',
          'g6f',
          'p5e',
          'c6a',
          'inf2',
        ],
      ],
    ]),
  ],
  [
    'Set7',
    new Map<string, string[]>([
      ['AMD EPYC 7R32', ['c5a', 'g5', 'c5ad', 'g4ad', 'gr6']],
    ]),
  ],
  [
    'Set8',
    new Map<string, string[]>([
      ['AMD EPYC 7571', ['t3a', 'r5ad', 'r5a', 'm5a', 'm5ad']],
    ]),
  ],
  [
    'Set9',
    new Map<string, string[]>([
      ['AMD EPYC 9R14 Processor', ['hpc7a', 'r7a', 'm7a', 'c7a']],
    ]),
  ],
  [
    'Set10',
    new Map<string, string[]>([
      [
        'Intel Xeon E5-2686 v4 (Broadwell)',
        ['i3', 'r4', 'p2', 'g3', 'g3s', 'h1', 'f1', 'p3', 'm4'],
      ],
    ]),
  ],
  [
    'Set12',
    new Map<string, string[]>([
      ['High Frequency Intel Xeon E7-8880 v3 (Haswell)', ['x1e', 'x1']],
    ]),
  ],
  [
    'Set13',
    new Map<string, string[]>([['Graviton (Cortex-A72, ARMv8.0-A)', ['a1']]]),
  ],
  [
    'Set14',
    new Map<string, string[]>([
      [
        'Graviton2 (Neoverse N1, ARMv8.2-A)',
        [
          'c6g',
          'c6gd',
          'c6gn',
          'g5g',
          'i4g',
          'im4gn',
          'is4gen',
          'm6g',
          'm6gd',
          'r6g',
          'r6gd',
          't4g',
          'x2gd',
        ],
      ],
    ]),
  ],
  [
    'Set15',
    new Map<string, string[]>([
      [
        'Graviton3 (Neoverse V1, ARMv8.4-A)',
        ['c7g', 'c7gd', 'c7gn', 'hpc7g', 'm7g', 'm7gd', 'r7g', 'r7gd'],
      ],
    ]),
  ],
  [
    'Set16',
    new Map<string, string[]>([
      [
        'Graviton4 (Neoverse V2, ARMv9.0-A)',
        [
          'c8g',
          'c8gd',
          'c8gn',
          'i8g',
          'i8ge',
          'm8g',
          'm8gd',
          'r8g',
          'r8gb',
          'r8gd',
          'r8gn',
          'x8g',
        ],
      ],
    ]),
  ],
]);

const GKE_INSTANCE_COMPATIBILITY_MAP: CompatibilityMap = new Map([
  ['Set1', new Map([['AMD EPYC Genoa', ['c3d']]])],
  ['Set2', new Map([['AMD EPYC Milan', ['c2d', 't2d']]])],
  ['Set3', new Map([['Intel Cascade Lake', ['c2', 'm2']]])],
  ['Set4', new Map([['Intel Emerald Rapids', ['m4', 'n4']]])],
  ['Set5', new Map([['Intel Ice Lake', ['m3']]])],
  ['Set6', new Map([['Intel Sapphire Rapids', ['c3', 'h3', 'z3']]])],
]);

const AKS_INSTANCE_COMPATIBILITY_MAP: CompatibilityMap = new Map([
  [
    'Set1',
    new Map([['AMD EPYC 7452 (Rome)', ['standard_DAv4', 'standard_DASv4']]]),
  ],
  [
    'Set2',
    new Map([
      [
        'AMD EPYC 9004 / 9005 (Genoa / Turin)',
        [
          'standard_DADSv6',
          'standard_DALDSv6',
          'standard_DALSv6',
          'standard_DASv6',
          'standard_EADSv6',
          'standard_EASv6',
          'standard_FALSv6',
          'standard_FAMSv6',
          'standard_FASv6',
          'standard_DADSv7',
          'standard_DALDSv7',
          'standard_DALSv7',
          'standard_DASv7',
          'standard_EADSv7',
          'standard_EASv7',
          'standard_FALSv7',
          'standard_FAMSv7',
          'standard_FASv7',
        ],
      ],
    ]),
  ],
  [
    'Set3',
    new Map([
      [
        'Intel Xeon Scalable (Emerald Rapids / Granite Rapids)',
        [
          'standard_EBDSv6',
          'standard_EBSv6',
          'standard_DDSv7',
          'standard_DLDSv7',
          'standard_DLSv7',
          'standard_DSv7',
          'standard_EDSv7',
          'standard_ESv7',
        ],
      ],
    ]),
  ],
]);

export const INSTANCE_COMPATIBILITY_MAPS: Partial<
  Record<K8sProvider, CompatibilityMap>
> = {
  [K8sProvider.EKS]: AWS_INSTANCE_COMPATIBILITY_MAP,
  [K8sProvider.GKE]: GKE_INSTANCE_COMPATIBILITY_MAP,
  [K8sProvider.AKS]: AKS_INSTANCE_COMPATIBILITY_MAP,
};

export const ALL_INSTANCES_BY_PROVIDER: Partial<
  Record<K8sProvider, Set<string>>
> = Object.fromEntries(
  Object.entries(INSTANCE_COMPATIBILITY_MAPS).map(([provider, map]) => [
    provider,
    buildAllInstances(map),
  ])
);

export const UNMIGRATABLE_INSTANCES_BY_PROVIDER: Partial<
  Record<K8sProvider, string[]>
> = {
  [K8sProvider.EKS]: [],
  [K8sProvider.GKE]: ['n1', 'm1', 'n2', 'n2d', 'c4'],
  [K8sProvider.AKS]: [
    'standard_DADSv5',
    'standard_DASv5',
    'standard_DDSv4',
    'standard_DDSv5',
    'standard_DDv4',
    'standard_DDv5',
    'standard_DSv4',
    'standard_DSv5',
    'standard_Dv4',
    'standard_Dv5',
    'standard_EADSv5',
    'standard_EASv5',
    'standard_EDSv5',
    'standard_EDv5',
    'standard_ESv5',
    'standard_Ev5',
    'standard_FSv2',
  ],
};
